import React, { useState, useEffect, useMemo } from "react";
import { useFormikContext } from "formik";
import { Input } from "reactstrap";
import AppFormError from "./AppFormError";
import AppFormLabel from "./AppFormLabel";
import CreatableSelect from "react-select/creatable";
import * as _ from "lodash";

function AppFormTagBox({
  name,
  width,
  label,
  options,
  required = false,
  isMultiple = true,
  additionalData = {},
  numbersOnly = false,
  ...otherProps
}) {
  const { setFieldTouched, setFieldValue, values, errors, touched } =
    useFormikContext();

  const [value, setValue] = useState(options ?? []);
  const [inputValue, setInputValue] = useState();

  useEffect(() => {
    setValue(options ?? []);
  }, [options]);

  const onChange = (option) => {
    setValue(option);
    setFieldValue(name, option);
  };

  const createOption = (label) => ({
    label,
    ...additionalData,
  });

  const handleInputChange = (value) => {
    // If numbersOnly is true, only allow numeric input
    if (numbersOnly && value && !/^\d*$/.test(value)) {
      return;
    }
    setInputValue(value);
  };

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        // If numbersOnly is true, verify the input is numeric before creating a new option
        if (numbersOnly && !/^\d*$/.test(inputValue)) {
          return;
        }
        const newOption = createOption(inputValue);
        setValue([...value, newOption]);
        setFieldValue(name, [...value, newOption]);
        event.preventDefault();
        setInputValue("");
    }
  };

  return (
    <>
      {<AppFormLabel label={label} required={required} />}
      {values && (
        <>
          <CreatableSelect
            inputValue={inputValue}
            isClearable
            isMulti={isMultiple}
            onChange={onChange}
            options={options}
            value={value}
            menuIsOpen={false}
            onBlur={() => setFieldTouched(name)}
            {...otherProps}
            onKeyDown={handleKeyDown}
            onInputChange={handleInputChange}
          />
        </>
      )}
      {!values && (
        <Input
          onBlur={() => setFieldTouched(name)}
          onChange={(event) => setFieldValue(name, event.value)}
          type={numbersOnly ? "number" : "text"}
          {...otherProps}
        />
      )}
      <AppFormError
        visible={_.get(touched, name)}
        error={_.get(errors, name)}
      ></AppFormError>
    </>
  );
}

export default AppFormTagBox;
